import amplitude from 'amplitude-js';

import { Platform } from './constants';
import { getPlatform } from './utils';
import UserSession from './UserSession';
import handlePhotoSessionsActions from './handlers/handlePhotoSessionsActions';
import handleIssueReportActions from './handlers/handleIssueReportActions';
import handleChecklistActions from './handlers/handleChecklistActions';
import handleRescheduleActions from './handlers/handleRescheduleActions';
import handlePropertyAssessmentActions from './handlers/handlePropertyAssessmentActions';

const setupAmplitude = () => {
  if (process.env.AMPLITUDE_API_KEY === undefined) return undefined;

  const amplitudeInstance = amplitude.getInstance();
  const isMobile = getPlatform() === Platform.mobile;

  amplitudeInstance.init(process.env.AMPLITUDE_API_KEY, null, {
    includeUtm: true,
    includeGclid: true,
    includeReferrer: true,
    batchEvents: isMobile,
    eventUploadThreshold: 5,
  });

  const sessionId = amplitude.getInstance().getSessionId();
  return new UserSession(sessionId, amplitude.getInstance());
};

const handleAmplitudeUserSession = (session) => {
  const uri = window.location.href || '';
  const payload = { entrance_uri: uri };

  if (session.validateSessionId()) return false;

  if (session.checkFirstUser()) {
    session.hydrateSessionId();
    payload.initial_entrance_uri = payload.entrance_uri;
  } else {
    session.refreshUserSession();
    session.hydrateSessionId();
  }

  return session.sendInfoToAmplitude(payload);
};

const amplitudeMiddleware = ({
  userSession,
  amplitudeInstance,
  next,
  action,
}) => {
  const result = next(action);

  if (userSession !== null) {
    handleAmplitudeUserSession(userSession);
  }

  handlePhotoSessionsActions(amplitudeInstance, action);
  handleIssueReportActions(amplitudeInstance, action);
  handleChecklistActions(amplitudeInstance, action);
  handleRescheduleActions(amplitudeInstance, action);
  handlePropertyAssessmentActions(amplitudeInstance, action);

  return result;
};

export {
  setupAmplitude,
  handleAmplitudeUserSession,
  amplitudeMiddleware,
};
